/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I write a formula?`)
};

const es_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se escribe una fórmula?`)
};

const de_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie schreibe ich eine Formel?`)
};

const nl_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe schrijf ik een formule?`)
};

const fr_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment écrire une formule ?`)
};

const it_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si scrive una formula?`)
};

const pt_br2_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como escrevo uma fórmula?`)
};

const pt_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como escrevo uma fórmula?`)
};

const ja_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`化学式はどう書けばよいですか？`)
};

const zh_mw_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何书写化学式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_faq_q2", locale)
	if (locale === "en") return en_mw_faq_q2(inputs)
	if (locale === "es") return es_mw_faq_q2(inputs)
	if (locale === "de") return de_mw_faq_q2(inputs)
	if (locale === "nl") return nl_mw_faq_q2(inputs)
	if (locale === "fr") return fr_mw_faq_q2(inputs)
	if (locale === "it") return it_mw_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_mw_faq_q2(inputs)
	if (locale === "pt") return pt_mw_faq_q2(inputs)
	if (locale === "ja") return ja_mw_faq_q2(inputs)
	return zh_mw_faq_q2(inputs)
};